/**参考教材模块 */
import request from '../request/http';
/**查询参考教材列表 */
export function GetList(data){
    return request({
        url: '/sp/courseReference/getList',
        method: 'post',
        data
    })
}
/**更新参考教材 */
export function UpdateCourseReference(data){
    return request({
        url: '/sp/courseReference/updateCourseReference',
        method: 'post',
        data
    })
}